import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M16.445 22.377H7.504a1.916 1.916 0 0 1-1.916-1.916v-3.944a1.325 1.325 0 0 1 1.325-1.325h10.122a1.325 1.325 0 0 1 1.325 1.325v3.944a1.916 1.916 0 0 1-1.915 1.916m-9.26-5.588v3.672a.327.327 0 0 0 .319.32h8.94a.327.327 0 0 0 .32-.32v-3.672zM18.36 8.806H5.588V3.537a1.916 1.916 0 0 1 1.916-1.915h8.94a1.916 1.916 0 0 1 1.916 1.915zM7.185 7.21h9.579V3.537a.32.32 0 0 0-.32-.319h-8.94a.32.32 0 0 0-.32.32zM8.382 11.744a.798.798 0 1 0 0-1.597.798.798 0 0 0 0 1.597M4.39 11.744a.798.798 0 1 0 0-1.597.798.798 0 0 0 0 1.597" }),
      _createElementVNode("path", { d: "M22.352 17.188v.2a1 1 0 0 1-.998.997H18.36v-1.868a1.326 1.326 0 0 0-1.325-1.325H6.913a1.325 1.325 0 0 0-1.325 1.325v1.868H2.594a1 1 0 0 1-.997-.997V9.804a1 1 0 0 1 .997-.998h18.76a1 1 0 0 1 .998.998za.798.798 0 0 0 1.596 0V9.804a2.594 2.594 0 0 0-2.594-2.594H2.594A2.594 2.594 0 0 0 0 9.804v7.584a2.595 2.595 0 0 0 2.594 2.594h4.59v-3.193h9.58v3.193h4.59a2.595 2.595 0 0 0 2.594-2.594v-.2a.798.798 0 0 0-1.596 0" })
    ], -1)
  ]))]))
}
export default { render: render }